import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import { PendingLeaderboardRow } from "./PendingLeaderboardItem";
import { PendingLeaderboardFields } from "components/events/judging/pending/usePendingLeaderboard";
import { PendingScoresAndTies } from "components/events/judging/pending/usePendingScoresAndTies";
import { Sx } from "utils/sx";

const actionAreaStyles: Sx = ({
    display: "flex",
    flexDirection: "column",
    gap: 0.5,
});

const accordionStyles: Sx = theme => ({
    boxShadow: theme.shadows.custom[1],
});

const accordionSummaryStyles: Sx = theme => ({
    "&:hover": {
        backgroundColor: theme.palette.background.lowest
    }
});

const accordionDetailsStyles: Sx = theme => ({
    p: theme.spacing(0, 2, 2, 2),
    filter: theme.shadows.filter[0],
});

export const PendingLeaderboardActionArea: React.FC<{
    actionItems: PendingScoresAndTies["actionItems"]
    competitorsAndResultsById: Record<string, {
        competitor: PendingLeaderboardFields["competitors"][number],
        result: PendingLeaderboardFields["result"][number]
    }>;
    heat: Pick<PendingLeaderboardFields, "result" | "config">;
}> = ({ actionItems, competitorsAndResultsById, heat }) => {
    if (actionItems.length === 0) {
        return null;
    }

    return (
        <Accordion defaultExpanded square disableGutters sx={accordionStyles}>
            <AccordionSummary expandIcon={<ExpandMore color='primary' fontSize='small' />} id="action-area" aria-controls="action-items" sx={accordionSummaryStyles}>
                <Typography variant="label2" color="textSecondary" textTransform="uppercase">Pending Scores</Typography>
            </AccordionSummary>
            <AccordionDetails sx={accordionDetailsStyles}>
                <Box sx={actionAreaStyles}>
                    {actionItems.map((({ index, isTied, ride }) => {
                        const result = heat.result[index];
                        const resultData = competitorsAndResultsById[result.athleteId];
                        if (!resultData) return null;

                        return <PendingLeaderboardRow
                            key={result.athleteId}
                            competitor={resultData.competitor}
                            result={resultData.result}
                            pendingResult={result}
                            heat={heat}
                            pendingRide={ride}
                            tied={isTied}
                            isActionItem
                        />;
                    }))}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};
